"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchFailedToFetch = void 0;
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
const http_interfaces_1 = require("../types/http.interfaces");
const FAILED_TO_FETCH = "failed to fetch";
/**
 * Our lowest level send is a wrapper around window.fetch. The promise returned from fetch()
 * will only reject on network failure or if anything prevented the request from completing (with a TypeError of all things).
 * Other send decorators in our code base can return promises rejected with our own IError
 * objects. So this function rejects the failed fetches.
 * This also prevents an unhandled promise rejection from bubbling up to the window.
 * Instead our own error is bubbling up and can still be caught by the caller.
 * The same transformation is used for cancelling requests - AbortError is transformed to ErrorReason.RequestCancelled
 */
function catchFailedToFetch(send) {
    return async (request) => {
        try {
            return await send(request);
        }
        catch (err) {
            if (err instanceof TypeError) {
                if (err.message?.toLowerCase() === FAILED_TO_FETCH) {
                    // Chrome is failing with typeError when getting cached resource
                    // https://developer.mozilla.org/en-US/docs/Web/API/Request/cache#value
                    const cacheHeader = request.headers && request.headers["cache"];
                    if (cacheHeader && cacheHeader.indexOf("only-if-cached") !== -1) {
                        return {
                            status: http_interfaces_1.Status.GATEWAY_TIMEOUT,
                        };
                    }
                    throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.RejectHttpError, undefined, err);
                }
            }
            if (err.name === "AbortError") {
                throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.RequestCancelled);
            }
            throw err;
        }
    };
}
exports.catchFailedToFetch = catchFailedToFetch;
